export default {"src":"/_next/static/media/gio_sig.4a0654a9.svg","height":21,"width":261,"blurWidth":0,"blurHeight":0};